// frontend/src/components/AppFooter.tsx
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/** One quiet line at the bottom of the app.
 *
 *  The terms have to be permanently accessible, not only reachable on the
 *  morning somebody signed up (art. 3:15d BW for the company details, art.
 *  6:234 BW for the terms themselves). A footer is the cheapest way to make
 *  "permanently" true.
 */
export function AppFooter() {
  const { t } = useTranslation();
  return (
    <footer className="mt-auto border-t border-border-subtle px-lg py-md">
      <nav className="flex flex-wrap items-center gap-md text-caption text-text-muted">
        <Link to="/legal/voorwaarden" className="hover:text-text-primary">{t('legal.terms')}</Link>
        <Link to="/legal/privacy" className="hover:text-text-primary">{t('legal.privacy')}</Link>
        <Link to="/legal/verwerkersovereenkomst" className="hover:text-text-primary">{t('legal.dpa')}</Link>
        <Link to="/legal/subverwerkers" className="hover:text-text-primary">{t('legal.subprocessors')}</Link>
        <Link to="/legal/bedrijfsgegevens" className="hover:text-text-primary">{t('legal.company')}</Link>
      </nav>
    </footer>
  );
}
